import styled from "@emotion/styled/macro";
import { tokens } from "@sunrun/experience-ui-components";

const LinkButton = styled.a<{ disabled?: boolean }>`
  text-decoration: none;
  background-color: ${tokens.BRAND_HEROBLUE};
  display: flex;
  height: 48px;
  border-radius: 80px;
  padding: 0px 32px;

  justify-content: center;
  align-items: center;

  color: ${tokens.WHITE};
  text-align: center;
  font-family: Roobert;
  font-size: ${tokens.FONT_SIZE_1}px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.32px;

  &:hover {
    opacity: 0.8;
  }
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.3;
    cursor: not-allowed;

    &:hover {
      opacity: 0.3;
      cursor: not-allowed;
    }

  `}
`;

export { LinkButton };
